import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FormEventService {
  private saveOccurredSource = new Subject<void>();
  
  // Observable stream for Component B to listen to
  saveOccurred$ = this.saveOccurredSource.asObservable();

  notifySave() {
    this.saveOccurredSource.next();
  }
}
